// Imports
import { Base, DataTypes } from '@mixins/forms'
import GtkSubmit from '../../mixins/gtk-submit'
import GtkError from '../../mixins/gtk-error'

// Parts
const { ObjectDataType: dataType } = DataTypes
const submitType = GtkSubmit
const errorHandling = GtkError

// Options
const options = {
  name: 'charge-room-form',
  dataType,
  submitType,
  errorHandling,
  submitOnChange: false,
  skipValidation: false,
  nativeSubmit: true
}

// Component
export default {
  name: options.name,
  mixins: [
    Base(options),
  ],
  mounted() {
    this.selectWifiOptions()
  },
  methods: {
     
    transformData(data) {
      const selected = this.form.find(`input[value="${data.wifi}"]`)
      const wifiOption = selected.data('wifi')
      const durationOption = selected.data('duration')
      return {
        billingOptionName: wifiOption,
        billingOptionDuration: durationOption,
      }
    },
    selectWifiOptions() {
      const wifiOptions = Array.from(document.querySelectorAll('.form-charge-room .wifi-option'))
      wifiOptions.forEach((option) => option.addEventListener('click', (el) => {
        const input = option.querySelector('input')
        for (let opt of wifiOptions) {
          opt.classList.remove('active')
        }
        option.classList.add('active')
        input.click()
      }))
    }
  }
}